/* Institution logo registry.
 *
 * Single source of truth for bank/institution logos used across all surfaces.
 * All logos are bundled inline SVGs (zero external dependency, zero network
 * requests). Brand glyphs sourced from simple-icons where available; custom
 * inline SVGs for institutions simple-icons does not cover.
 *
 * simple-icons coverage (checked v16):
 *   Revolut, Wise, Barclays, HSBC, Monzo, Starling Bank  -- covered
 *   BNP Paribas, NatWest, RBS, Lloyds, Agora              -- not covered
 *
 * Adding a logo: add an entry to bankSvgLogos AND reference it via the
 * `logo` key in bankLogoConfig. Institutions without a logo key in
 * bankLogoConfig render a letter avatar automatically.
 */

// ---- simple-icons SVG paths (24x24 viewBox) --------------------------------
// Extracted from simple-icons at install time. Rendered inside a 32x32 rounded
// rect with translate(4,4) to center the 24x24 glyph.

const SI_PATHS = {
  revolut: 'M20.9133 6.9566C20.9133 3.1208 17.7898 0 13.9503 0H2.424v3.8605h10.9782c1.7376 0 3.177 1.3651 3.2087 3.043.016.84-.2994 1.633-.8878 2.2324-.5886.5998-1.375.9303-2.2144.9303H9.2322a.2756.2756 0 0 0-.2755.2752v3.431c0 .0585.018.1142.052.1612L16.2646 24h5.3114l-7.2727-10.094c3.6625-.1838 6.61-3.2612 6.61-6.9494zM6.8943 5.9229H2.424V24h4.4704z',
  wise: 'M6.488 7.469 0 15.05h11.585l1.301-3.576H7.922l3.033-3.507.01-.092L8.993 4.48h8.873l-6.878 18.925h4.706L24 .595H2.543l3.945 6.874Z',
  barclays: 'M21.043 3.629a3.235 3.235 0 0 0-1.048-.54 3.076 3.076 0 0 0-.937-.144h-.046c-.413.006-1.184.105-1.701.71a1.138 1.138 0 0 0-.226 1.023.9.9 0 0 0 .555.63s.088.032.228.058c-.04.078-.136.214-.136.214-.179.265-.576.612-1.668.612h-.063c-.578-.038-1.056-.189-1.616-.915-.347-.45-.523-1.207-.549-2.452-.022-.624-.107-1.165-.256-1.6-.1-.29-.333-.596-.557-.742a2.55 2.55 0 0 0-.694-.336c-.373-.12-.848-.14-1.204-.146-.462-.01-.717.096-.878.292-.027.033-.032.05-.068.046-.084-.006-.272-.006-.328-.006-.264 0-.498.043-.721.09-.47.1-.761.295-1.019.503-.12.095-.347.365-.399.653a.76.76 0 0 0 .097.578c.14-.148.374-.264.816-.266.493-.002 1.169.224 1.406.608.336.547.27.99.199 1.517-.183 1.347-.68 2.048-1.783 2.203-.191.026-.38.04-.56.04-.776 0-1.34-.248-1.63-.716a.71.71 0 0 1-.088-.168s.087-.021.163-.056c.294-.14.514-.344.594-.661.09-.353.004-.728-.23-1.007-.415-.47-.991-.708-1.713-.708-.4 0-.755.076-.982.14-.908.256-1.633.947-2.214 2.112-.412.824-.7 1.912-.81 3.067-.11 1.13-.056 2.085.019 2.949.124 1.437.363 2.298.708 3.22a15.68 15.68 0 0 0 1.609 3.19c.09-.094.15-.161.308-.318.188-.19.724-.893.876-1.11.19-.27.51-.779.664-1.147l.15.119c.16.127.252.348.249.592-.003.215-.053.464-.184.922a8.703 8.703 0 0 1-.784 1.818c-.189.341-.27.508-.199.584.015.015.038.03.06.026.116 0 .34-.117.585-.304.222-.17.813-.672 1.527-1.675a15.449 15.449 0 0 0 1.452-2.521c.12.046.255.101.317.226a.92.92 0 0 1 .08.563c-.065.539-.379 1.353-.63 1.94-.425.998-1.208 2.115-1.788 2.877-.022.03-.163.197-.186.227.9.792 1.944 1.555 3.007 2.136.725.408 2.203 1.162 3.183 1.424.98-.262 2.458-1.016 3.184-1.424a17.063 17.063 0 0 0 3.003-2.134c-.05-.076-.13-.158-.183-.23-.582-.763-1.365-1.881-1.79-2.875-.25-.59-.563-1.405-.628-1.94-.028-.221-.002-.417.08-.565.033-.098.274-.218.317-.226.405.884.887 1.73 1.452 2.522.715 1.003 1.306 1.506 1.527 1.674.248.191.467.304.586.304a.07.07 0 0 0 .044-.012c.094-.069.017-.234-.183-.594a9.003 9.003 0 0 1-.786-1.822c-.13-.456-.18-.706-.182-.92-.004-.246.088-.466.248-.594l.15-.118c.155.373.5.919.665 1.147.15.216.685.919.876 1.11.156.158.22.222.308.32a15.672 15.672 0 0 0 1.609-3.19c.343-.923.583-1.784.707-3.222.075-.86.128-1.81.02-2.948-.101-1.116-.404-2.264-.81-3.068-.249-.49-.605-1.112-1.171-1.566z',
  hsbc: 'm24 12.007-5.996 5.997V5.996L24 12.007zm-5.996-6.01H6.01l5.996 6.01 5.997-6.01zM0 12.006l6.01 5.997V5.996L0 12.007zm6.01 5.997h11.994l-5.997-5.997-5.996 5.997z',
  monzo: 'M4.244 1.174a.443.443 0 00-.271.13l-3.97 3.97-.001.001c3.884 3.882 8.093 8.092 11.748 11.748v-8.57L4.602 1.305a.443.443 0 00-.358-.131zm15.483 0a.443.443 0 00-.329.13L12.25 8.456v8.568L24 5.275c-1.316-1.322-2.647-2.648-3.97-3.97a.443.443 0 00-.301-.131zM0 5.979l.002 10.955c0 .294.118.577.326.785l4.973 4.976c.28.282.76.083.758-.314V12.037zm23.998.003l-6.06 6.061v10.338c-.004.399.48.6.76.314l4.974-4.976c.208-.208.326-.49.326-.785z',
  starling: 'M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm2.738 3.822h.666v2.724h-.666a4.794 4.794 0 0 0-4.789 4.788V12H7.226v-.666c0-4.142 3.37-7.512 7.512-7.512zM14.05 12h2.723v.666c0 4.142-3.37 7.512-7.512 7.512h-.666v-2.724h.666a4.794 4.794 0 0 0 4.789-4.788z',
};

/** Render a simple-icons glyph inside a 32x32 rounded-rect chip. */
function SiGlyph({ path, bg, fill, s }) {
  return (
    <svg width={s} height={s} viewBox="0 0 32 32" fill="none">
      <rect width="32" height="32" rx="6" fill={bg} />
      <g transform="translate(4,4)"><path d={path} fill={fill} /></g>
    </svg>
  );
}

// ---- Custom inline SVGs (institutions not in simple-icons) ------------------

const bankSvgLogos = {
  revolut: (s) => <SiGlyph path={SI_PATHS.revolut} bg="#0A1E3D" fill="#FFFFFF" s={s} />,
  wise: (s) => <SiGlyph path={SI_PATHS.wise} bg="#9FE870" fill="#163300" s={s} />,
  barclays: (s) => <SiGlyph path={SI_PATHS.barclays} bg="#00AEEF" fill="#FFFFFF" s={s} />,
  hsbc: (s) => (
    <svg width={s} height={s} viewBox="0 0 32 32" fill="none">
      <rect width="32" height="32" rx="6" fill="white" />
      <g transform="translate(4,4)"><path d={SI_PATHS.hsbc} fill="#DB0011" /></g>
    </svg>
  ),
  monzo: (s) => <SiGlyph path={SI_PATHS.monzo} bg="#FF3464" fill="#FFFFFF" s={s} />,
  starling: (s) => <SiGlyph path={SI_PATHS.starling} bg="#6935D3" fill="#FFFFFF" s={s} />,
  natwest: (s) => (
    <svg width={s} height={s} viewBox="0 0 32 32" fill="none">
      <rect width="32" height="32" rx="6" fill="#42145F"/>
      <g transform="translate(16,16)">
        <rect x="-2" y="-10" width="4" height="10" rx="0.5" fill="white" transform="rotate(0)"/>
        <rect x="-2" y="-10" width="4" height="10" rx="0.5" fill="white" transform="rotate(60)"/>
        <rect x="-2" y="-10" width="4" height="10" rx="0.5" fill="white" transform="rotate(120)"/>
        <rect x="-2" y="-10" width="4" height="10" rx="0.5" fill="#FF6B00" transform="rotate(180)"/>
        <rect x="-2" y="-10" width="4" height="10" rx="0.5" fill="#FF6B00" transform="rotate(240)"/>
        <rect x="-2" y="-10" width="4" height="10" rx="0.5" fill="#FF6B00" transform="rotate(300)"/>
      </g>
    </svg>
  ),
  lloyds: (s) => (
    <svg width={s} height={s} viewBox="0 0 32 32" fill="none">
      <rect width="32" height="32" rx="6" fill="#024731"/>
      <path d="M22 22c-1-1-3-2-5-2s-5 .5-7 2c0 0 1-4 3-7 1.5-2.5 3-4 4-4s2.5 1.5 4 4c2 3 3 7 3 7h-2z" fill="white"/>
      <ellipse cx="17" cy="11" rx="3" ry="4" fill="white" transform="rotate(-10 17 11)"/>
      <path d="M14 9c1-2 2-3 3.5-3s2 1 2 2-1.5 2-3 2.5" stroke="#024731" strokeWidth="0.8" fill="none"/>
    </svg>
  ),
  rbs: (s) => (
    <svg width={s} height={s} viewBox="0 0 32 32" fill="none">
      <rect width="32" height="32" rx="6" fill="#0A2044"/>
      <path d="M8 12l8-8 8 8-8 8z" fill="white" opacity="0.9"/>
      <path d="M8 20l8-8 8 8-8 8z" fill="white" opacity="0.5"/>
    </svg>
  ),
  bnp: (s) => (
    <svg width={s} height={s} viewBox="0 0 32 32" fill="none">
      <rect width="32" height="32" rx="6" fill="#008859"/>
      <text x="16" y="20" textAnchor="middle" fontFamily="Arial,Helvetica,sans-serif" fontSize="11" fontWeight="bold" fill="white" letterSpacing="0.5">BNP</text>
    </svg>
  ),
  bcp: (s) => (
    <svg width={s} height={s} viewBox="0 0 32 32" fill="none">
      <rect width="32" height="32" rx="6" fill="#004990"/>
      <text x="16" y="20" textAnchor="middle" fontFamily="Arial,Helvetica,sans-serif" fontSize="11" fontWeight="bold" fill="white" letterSpacing="0.5">BCP</text>
    </svg>
  ),
};

export const bankLogoConfig = {
  'Revolut Business': { bg: '#0A1E3D', color: '#FFFFFF', initials: 'RB', logo: 'revolut' },
  'Revolut':          { bg: '#0A1E3D', color: '#FFFFFF', initials: 'RE', logo: 'revolut' },
  'RBS':              { bg: '#0A2044', color: '#FFFFFF', initials: 'RBS', logo: 'rbs' },
  'NatWest':          { bg: '#42145F', color: '#FFFFFF', initials: 'NW', logo: 'natwest' },
  'BNP Paribas':      { bg: '#008859', color: '#FFFFFF', initials: 'BNP', logo: 'bnp' },
  'Wise':             { bg: '#9FE870', color: '#163300', initials: 'W',  logo: 'wise' },
  'Barclays':         { bg: '#00AEEF', color: '#FFFFFF', initials: 'BA', logo: 'barclays' },
  'HSBC':             { bg: '#DB0011', color: '#FFFFFF', initials: 'HSBC', logo: 'hsbc' },
  'Lloyds':           { bg: '#024731', color: '#FFFFFF', initials: 'LL', logo: 'lloyds' },
  'Agora':            { bg: '#7C3AED', color: '#FFFFFF', initials: 'AG' },
  'Monzo':            { bg: '#FF3464', color: '#FFFFFF', initials: 'MZ', logo: 'monzo' },
  'Starling':         { bg: '#6935D3', color: '#FFFFFF', initials: 'SB', logo: 'starling' },
  'Banque BCP':       { bg: '#004990', color: '#FFFFFF', initials: 'BCP', logo: 'bcp' },
};

// Keyword-based alias table for normalized institution matching.
// Prod bank_name values (e.g. "Bnp Fr", "REVOLUT") may not match
// exact keys in bankLogoConfig. Each entry maps a lowercase keyword
// to the exact bankLogoConfig key. Checked in order; first match wins.
// More specific keywords come first to avoid false positives
// (e.g. "revolut business" before "revolut").
const INSTITUTION_ALIASES = [
  { keyword: 'revolut business', config: 'Revolut Business' },
  { keyword: 'revolut',          config: 'Revolut' },
  { keyword: 'bnp',              config: 'BNP Paribas' },
  { keyword: 'bcp',              config: 'Banque BCP' },
  { keyword: 'natwest',          config: 'NatWest' },
  { keyword: 'rbs',              config: 'RBS' },
  { keyword: 'wise',             config: 'Wise' },
  { keyword: 'barclays',         config: 'Barclays' },
  { keyword: 'hsbc',             config: 'HSBC' },
  { keyword: 'lloyds',           config: 'Lloyds' },
  { keyword: 'agora',            config: 'Agora' },
  { keyword: 'monzo',            config: 'Monzo' },
  { keyword: 'starling',         config: 'Starling' },
];

/** Resolve bankName to a bankLogoConfig entry via exact match or keyword alias. */
export function resolveLogoConfig(bankName) {
  // Exact match (fast path)
  if (bankLogoConfig[bankName]) return bankLogoConfig[bankName];
  // Normalized keyword matching
  var lower = String(bankName ?? '').toLowerCase();
  for (var i = 0; i < INSTITUTION_ALIASES.length; i++) {
    if (lower.indexOf(INSTITUTION_ALIASES[i].keyword) !== -1) {
      return bankLogoConfig[INSTITUTION_ALIASES[i].config];
    }
  }
  return null;
}

export function BankLogo({ bankName, size = 'md' }) {
  const cfg = resolveLogoConfig(bankName);
  const px = size === 'sm' ? 24 : 36;
  const cls = size === 'sm' ? 'w-6 h-6 rounded' : 'w-9 h-9 rounded-lg';

  if (cfg && cfg.logo && bankSvgLogos[cfg.logo]) {
    return (
      <div className={`${cls} shrink-0 overflow-hidden flex items-center justify-center`}>
        {bankSvgLogos[cfg.logo](px)}
      </div>
    );
  }

  // Letter avatar fallback (used for unmapped institutions or when
  // cfg has no logo key). Debug title names the unmatched identifier
  // so future misses are self-documenting.
  const fallback = cfg ?? {
    bg: '#6B7280',
    color: '#FFFFFF',
    initials: String(bankName ?? '?').slice(0, 2).toUpperCase(),
  };
  const textCls = size === 'sm' ? 'text-[9px]' : 'text-xs';
  return (
    <div
      className={`${cls} ${textCls} flex items-center justify-center font-bold shrink-0 tracking-tight`}
      style={{ backgroundColor: fallback.bg, color: fallback.color }}
      title={cfg ? undefined : `logo not found for key: ${bankName}`}
    >
      {fallback.initials}
    </div>
  );
}
